import React from "react";
import errorImg from "../../assets/error_page.svg";
import "./error_page.scss";
const ErrorPage = () => {
  return (
    <div className="error_page_main">
      <h1>PAGE NOT FOUND</h1>
      <img src={errorImg} alt="404 error" />
      <a href="/">
        <button>BACK TO HOME</button>
      </a>
    </div>
  );
};

export default ErrorPage;
